import React from "react";
import { Box, Avatar } from "@mui/material";
import { useCachedAvatar } from "../../hooks/useCachedAvatar";

/**
 * AvatarOnlyCard
 * WriterInfoCard에서 텍스트를 제거하고 아바타만 표시하는 컴포넌트
 * @param {object} props
 * @param {object} props.user - user doc minimal (expects id or profile.id)
 * @param {boolean} [props.isMobile]
 * @param {string|null} [props.fallbackAvatarUrl] - 폴백 아바타 URL
 * @param {number} [props.size] - 아바타 크기 (기본값: 모바일 40, 데스크톱 56)
 */
const AvatarOnlyCard = ({ user, isMobile, fallbackAvatarUrl = null, size }) => {
	const username = user?.profile?.username || user?.profile?.name || "";
	const userId = String(user?.id || user?.user_id || user?.profile?.id || "");

	// Avatar System: useCachedAvatar (public URL + progressive cache), with fallback
	const { imageSrc } = useCachedAvatar(userId, fallbackAvatarUrl, 160);

	const avatarSize = size || (isMobile ? 28 : 56);

	return (
		<Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
			<Avatar
				src={imageSrc || undefined}
				sx={{ 
					width: avatarSize, 
					height: avatarSize,
					border: '2px solid',
					borderColor: 'primary.main',
					bgcolor: 'background.paper'
				}}
			>
				{username ? username.charAt(0).toUpperCase() : "?"}
			</Avatar>
		</Box>
	);
};

export default AvatarOnlyCard;